import React from 'react';
import CommonCtaArea from '../../components/CommonCtaArea/CommonCtaArea';
import NavHeader from '../../components/NavHeader/NavHeader';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../components/shared/PageHelmet';
import HomeCapabilities from '../Home/HomeCapabilities/HomeCapabilities';
import HomeServices from '../Home/HomeServices/HomeServices';
import HomeTwoFooter from '../../components/MainFooter/MainFooter';

const Offerings = () => {
   return (
      <>
         <PageHelmet
            pageTitle="Digital Product & Growth Solutions"
            description="Harsoft Solutions: Build, Design, Automate, Grow. Web & mobile app development, Python & backend development, AI & intelligent automation, database & data solutions, UI/UX & product design, and digital marketing & SEO."
            keywords="Software Development Company, Web Development Company, Mobile App Development, AI Development Services, SaaS Development, Digital Product & Growth Solutions"
            path="/offerings"
         />

         <NavHeader />
         <main>
            <CommonPageHeader title="Digital Product & Growth Solutions" subtitle="Offerings" />
            <HomeServices />
            <HomeCapabilities />
            <CommonCtaArea />
         </main>
         <HomeTwoFooter />
      </>
   );
};

export default Offerings;